export default __webpack_public_path__ + "static/media/ow3.bc3b9d2c.webp";